import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RideWssAppConstants } from '@uzurv/rideWss/app/constants/ride-wss-app-contants';

@Component({
  selector: 'app-footer',
  standalone: true,
  template: `
    <footer class="footer">
      <span id="footer-text-copyright" class="copyright">
        <span aria-hidden="true">&#169;</span>
        {{ this.translateService.instant('footer.text.copyright', { year: currentYear }) }}
      </span>
      <span id="footer-text-version" role="none" class="version" [attr.aria-label]="'Version ' + version">
        <span aria-hidden="true">{{ version }}</span>
      </span>
      <a id="footer-link-privacyPolicy" href="https://uzurv.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
        {{ this.translateService.instant('footer.text.privacyPolicy') }}
      </a>
    </footer>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .footer {
        background-color: var(--rss-primary-white);
        min-height: 4.5rem;
        padding: 1rem var(--rss-gutter);
        box-sizing: border-box;

        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: var(--rss-gray-900);
        font-size: 16px;
        font-weight: 500;
        line-height: 150%;
      }

      .footer a {
        text-decoration: none;
      }

      .footer > * + *::before {
        content: '|';
        margin: 0 0.75rem;
      }

      #footer-link-privacyPolicy {
        min-width: 44px;
        min-height: 44px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0 0.5rem;
      }

      @media (max-width: 600px) {
        .footer {
          flex-direction: column;
          align-items: center;
          gap: 0.5rem;
        }

        .footer > * + *::before {
          content: none;
          margin: 0;
        }
      }
    `
  ]
})
export class FooterComponent {
  private _version: string = RideWssAppConstants.APPLICATION_VERSION;

  @Input()
  set version(value: string | null | undefined) {
    this._version = value ?? RideWssAppConstants.APPLICATION_VERSION;
  }

  get version(): string {
    return this._version;
  }

  readonly currentYear = new Date().getFullYear();

  constructor(public translateService: TranslateService) {}
}
